// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__DuHsk","info":"Chip_info__41G9n","attention":"Chip_attention__Y9u26","highlighted":"Chip_highlighted__AUnRy","plain":"Chip_plain__K837y"};